export default __webpack_public_path__ + "static/media/doctor-pending.89588a70.png";